const NS = 'CourseSearchBlock';
const CLS = 'courseSearchBlock';

export class CourseSearchBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.$input = this.$element.find(`.${CLS}-card-body-input`);
		this.$inputGroup = this.$element.find(`.${CLS}-card-body-inputGroup`);

		this.$input.on('focus', () => {
			this.$inputGroup.addClass('focus');
		});

		this.$input.on('blur', () => {
			this.$inputGroup.removeClass('focus');
		});
	}
}
